export const LAYOUT = {
  LANDSCAPE: 'landscape',
  PORTRAID: 'portraid',
}

export const AVATAR_POSITION = {
  TOP: 'top-view',
  MIDDLE: 'middle-view',
  BOTTOM: 'bottom-view',
}

export const KEY_STORE = 'settings'
